/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_State_OfflineInputs */

const en_signin_state_offline = /** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are offline. Connect to the internet to sign in.`)
};

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const ar_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const he_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const ur_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const es_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const fr_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const de_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const pt_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const hi_signin_state_offline = en_signin_state_offline;

/** @type {(inputs: Signin_State_OfflineInputs) => LocalizedString} */
const bn_signin_state_offline = en_signin_state_offline;

/**
* | output |
* | --- |
* | "You are offline. Connect to the internet to sign in." |
*
* @param {Signin_State_OfflineInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_state_offline = /** @type {((inputs?: Signin_State_OfflineInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_State_OfflineInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_state_offline(inputs)
	if (locale === "he") return he_signin_state_offline(inputs)
	if (locale === "ur") return ur_signin_state_offline(inputs)
	if (locale === "es") return es_signin_state_offline(inputs)
	if (locale === "fr") return fr_signin_state_offline(inputs)
	if (locale === "de") return de_signin_state_offline(inputs)
	if (locale === "pt") return pt_signin_state_offline(inputs)
	if (locale === "hi") return hi_signin_state_offline(inputs)
	if (locale === "bn") return bn_signin_state_offline(inputs)
	return /** @type {LocalizedString} */ ("You are offline. Connect to the internet to sign in.")
});